<p-toast></p-toast>
<div class="card mt-2">
    <div class="">
        <div class="flex align-items-center my-2 pb-2">
            <span
                [ngStyle]="{'color': 'rgb(125, 22, 22)', 'font-weight': 'bold', 'font-size': '1.0rem', 'display': 'flex', 'justify-content': 'center', 'align-items': 'left'}"
                class="font-bold">{{'POND_CONSOLIDATED_REPORT_DETAILS'| translate}}</span>
        </div>

        <div class="p-fluid p-formgrid grid filter-blocks">
            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'FINANCIAL_YEAR'| translate}}</label>
                <p-dropdown [options]="finYearList" appendTo="body" [(ngModel)]="selectedFinYear"
                    placeholder="{{'ALL'| translate}}" optionLabel="FinancialYears" [showClear]="true"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'DISTRICT'| translate}}</label>
                <p-dropdown [options]="districtList" appendTo="body" [(ngModel)]="selectedDistrict"
                    placeholder="{{'ALL'| translate}}" optionLabel="District" [showClear]="true"
                    (onChange)="onSelectDistrict()"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field" *ngIf="selectedDistrict">
                <label htmlFor="component">{{'BLOCK'| translate}}</label>
                <p-dropdown [options]="blockList" appendTo="body" [(ngModel)]="selectedBlock"
                    placeholder="{{'ALL'| translate}}" optionLabel="Block" [showClear]="true"
                    (onChange)="onSelectBlock()"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'CONSTITUENCY'| translate}}</label>
                <p-dropdown [options]="constituencyList" appendTo="body" [(ngModel)]="selectedconstituency"
                    placeholder="{{'ALL'| translate}}" optionLabel="Constituency" [showClear]="true"
                    (onChange)="onSelectConstituency()"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field" *ngIf="selectedBlock || selectedconstituency">
                <label htmlFor="component">{{'VILLAGE'| translate}}</label>
                <p-dropdown [options]="villageList" appendTo="body" [(ngModel)]="selectedVillage"
                    placeholder="{{'ALL'| translate}}" optionLabel="Village" [showClear]="true"></p-dropdown>
            </div>

            <!-- <div class="field col-6 md:col-2">
            <label htmlFor="villageCode">{{'VILLAGE' | translate}}</label>
            <p-autoComplete [(ngModel)]="seletedVillage"
                placeholder="{{'VILLAGE' | translate}}" id="dd" [dropdown]="true" [multiple]="false"
                [suggestions]="filteredVillage" (completeMethod)="filterVillage($event)" field="Name"
                value="Code"></p-autoComplete>
        </div> -->

            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'CROP_TYPE'| translate}}</label>
                <p-dropdown [options]="cropMergeList" appendTo="body" [(ngModel)]="selectedCrop"
                    placeholder="{{'ALL'| translate}}" optionLabel="label" [showClear]="true"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'CASTE'| translate}}</label>
                <p-dropdown [options]="casteList" appendTo="body" [(ngModel)]="selectedCaste"
                    placeholder="{{'ALL'| translate}}" optionLabel="Caste_Description" [showClear]="true"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2 filter-blocks-field">
                <label htmlFor="component">{{'User Type'| translate}}</label>
                <p-dropdown [options]="appTypeList" appendTo="body" [(ngModel)]="selectedAppType"
                    placeholder="{{'ALL'| translate}}" optionLabel="AppType_Description"
                    [showClear]="true"></p-dropdown>
            </div>

            <div class="field col-6 md:col-2">
                <button pButton pRipple type="button" label="{{'Apply Filter'| translate}}"
                    (click)="onClickApplyFilter()" class="p-button-primary mt-4">
                </button>
            </div>
        </div>
    </div>


    <div class="dashboardTable">
        <!-- <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button>
                <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button>
            </ng-template>
            <ng-template pTemplate="right">
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}"
                    icon="pi pi-upload" class="p-button-help"></button>

                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>
        </p-toolbar> -->
        <p-table #miSurvey [value]="consolidateData" dataKey="title" [rows]="10" [paginator]="false"
            [globalFilterFields]="[
            'title'
            ]" [rowHover]="true"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" (onFilter)="tableDataFunction($event)" (onPage)="onPage($event)"
            [loading]="loading" [scrollable]="true" scrollHeight="{{scrollHeight}}" responsiveLayout="scroll"
            [resizableColumns]="true" styleClass="p-datatable-gridlines" [tableStyle]="{'min-width': '300rem'}">
            <!-- <ng-template pTemplate="caption" *ngIf="consolidateData.length > 0">
                <div class="flex align-items-center justify-content-end">
                    <div class="p-input-icon-right">
                        <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-download"
                            class="p-button-help"></button>

                        <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                    </div>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template> -->
            <ng-template pTemplate="header">
                <tr class="header-sec-row">
                    <th pFrozenColumn pSortableColumn="title">{{ column1Name }}</th>
                  
                    <th class="top-header-1">{{'TOTAL_APP'| translate}}</th>
                    <th class="top-header-1">{{'TOTAL_AREA'| translate}}</th>
                    <th class="top-header-1">{{'VERIFIED_APP'| translate}}</th>
                    <th class="top-header-1">{{'VERIFIED_APP_AREA'| translate}}</th>
                    <!-- <th class="top-header-1">{{'PENDING_APP'| translate}}</th> -->
                    <th class="top-header-1">{{'INCOMPLETE_APP'| translate}}</th>
                    <th class="top-header-1">{{'INCOMPLETE_APP_AREA'| translate}}</th>
                    <th class="top-header-1">{{'REJECTED_APP'| translate}}</th>

                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->

                    <th class="top-header-2">{{'Total Intimation Stage 1'| translate}}</th>
                    <th class="top-header-2">{{'Verified Intimation Stage1'| translate}}</th>
                    <th class="top-header-2">{{'verified intimation stage1 area'| translate}}</th>
                    <th class="top-header-2">{{'pending intimation stage1'| translate}}</th> 
                    <th class="top-header-2">{{'total PV stage1'| translate}}</th>
                    <th class="top-header-2">{{'total PV stage1 Area'| translate}}</th>
                    <th class="top-header-2">{{'verified PV stage1'| translate}}</th>
                    <th class="top-header-2">{{'verified PV stage1 Area'| translate}}</th>
                    <th class="top-header-2">{{'pending PV stage1'| translate}}</th>
                    <th class="top-header-2">{{'rejected PV stage1'| translate}}</th>

                    <th class="top-header-2">{{'total subsidy calc stage1'| translate}}</th>
                    <th class="top-header-2">{{'total subsidy calc stage1 Area'| translate}}</th>
                    <th class="top-header-2">{{'verified subsidy calc stage1'| translate}}</th>
                    <th class="top-header-2">{{'verified subsidy calc stage1 Area'| translate}}</th>
                    <th class="top-header-2">{{'pending subsidy calc stage1'| translate}}</th>
                    <th class="top-header-2">{{'rejected subsidy calc stage1'| translate}}</th>

                    <th class="top-header-2">{{'total lot generated stage1'| translate}}</th>
                    <th class="top-header-2">{{'verified lot generated stage1'| translate}}</th>
                    <th class="top-header-2">{{'verified lot generated stage1 centershare'| translate}}</th>
                    <th class="top-header-2">{{'verified lot generated stage1 stateshare'| translate}}</th>
                    <th class="top-header-2">{{'pending lot generated stage1'| translate}}</th>

                    <th class="top-header-2">{{'total subsidy disbursal stage1'| translate}}</th>
                    <th class="top-header-2">{{'verified subsidy disbursal stage1'| translate}}</th>
                    <th class="top-header-2">{{'verified subsidy disbursal stage1 centershare'| translate}}</th>
                    <th class="top-header-2">{{'verified subsidy disbursal stage1 stateshare'| translate}}</th>
                    <th class="top-header-2">{{'pending subsidy disbursal stage1'| translate}}</th>

                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->

                    <th class="top-header-3">{{'total intimation stage2'| translate}}</th>
                    <th class="top-header-3">{{'verified intimation stage2'| translate}}</th>
                    <th class="top-header-3">{{'verified intimation stage2 area'| translate}}</th>
                    <th class="top-header-3">{{'pending intimation stage2'| translate}}</th>

                    <th class="top-header-3">{{'total PV stage2'| translate}}</th>
                    <th class="top-header-3">{{'total PV stage2 Area'| translate}}</th>
                    <th class="top-header-3">{{'verified PV stage2'| translate}}</th>
                    <th class="top-header-3">{{'verified PV stage2 Area'| translate}}</th>
                    <th class="top-header-3">{{'pending PV stage2'| translate}}</th>
                    <th class="top-header-3">{{'rejected PV stage2'| translate}}</th>

                    <th class="top-header-3">{{'total subsidy calc stage2'| translate}}</th>
                    <th class="top-header-3">{{'total subsidy calc stage2 Area'| translate}}</th>
                    <th class="top-header-3">{{'verified subsidy calc stage2'| translate}}</th>
                    <th class="top-header-3">{{'verified subsidy calc stage2 Area'| translate}}</th>
                    <th class="top-header-3">{{'pending subsidy calc stage2'| translate}}</th>
                    <th class="top-header-3">{{'rejected subsidy calc stage2'| translate}}</th>

                    <th class="top-header-3">{{'total lot generated stage2'| translate}}</th>
                    <th class="top-header-3">{{'verified lot generated stage2'| translate}}</th>
                    <th class="top-header-3">{{'verified lot generated stage2 centershare'| translate}}</th>
                    <th class="top-header-3">{{'verified lot generated stage2 stateshare'| translate}}</th>
                    <th class="top-header-3">{{'pending lot generated stage2'| translate}}</th>

                    <th class="top-header-3">{{'total subsidy disbursal stage2'| translate}}</th>
                    <th class="top-header-3">{{'verified subsidy disbursal stage2'| translate}}</th>
                    <th class="top-header-3">{{'verified subsidy disbursal stage2 centershare'| translate}}</th>
                    <th class="top-header-3">{{'verified subsidy disbursal stage2 stateshare'| translate}}</th>
                    <th class="top-header-3">{{'pending subsidy disbursal stage2'| translate}}</th>

                    <!-- <th [ngClass]="{'row-accessories': true}"></th> -->

                    <th class="top-header-4">{{'total subsidy calc stage3'| translate}}</th>
                    <th class="top-header-4">{{'total subsidy calc stage3 Area'| translate}}</th>
                    <th class="top-header-4">{{'verified subsidy calc stage3'| translate}}</th>
                    <th class="top-header-4">{{'verified subsidy calc stage3 Area'| translate}}</th>
                    <th class="top-header-4">{{'pending subsidy calc stage3'| translate}}</th>  
                    <th class="top-header-4">{{'rejected subsidy calc stage3'| translate}}</th>

                    <th class="top-header-4">{{'total lot generated stage3'| translate}}</th>
                    <th class="top-header-4">{{'verified lot generated stage3'| translate}}</th>
                    <th class="top-header-4">{{'verified lot generated stage3 centershare'| translate}}</th>
                    <th class="top-header-4">{{'verified lot generated stage3 stateshare'| translate}}</th>
                    <th class="top-header-4">{{'pending lot generated stage3'| translate}}</th>

                    <th class="top-header-4">{{'total subsidy disbursal stage3'| translate}}</th>
                    <th class="top-header-4">{{'verified subsidy disbursal stage3'| translate}}</th>
                    <th class="top-header-4">{{'verified subsidy disbursal stage3 centershare'| translate}}</th>
                    <th class="top-header-4">{{'verified subsidy disbursal stage3 stateshare'| translate}}</th>
                    <th class="top-header-4">{{'pending subsidy disbursal stage3'| translate}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-consolidateData>
                <tr class="body-section">
                    <td pFrozenColumn>{{consolidateData.title}}</td>
                    <td>{{consolidateData.totalApp}}</td>
                    <td>{{consolidateData.totalArea}}</td>
                    <td>{{consolidateData.verifiedApp}}</td>
                    <td>{{consolidateData.verifiedAppArea}}</td>
                    <td>{{consolidateData.IncompleteApp}}</td>
                    <td>{{consolidateData.IncompleteAppArea}}</td>
                    <td>{{consolidateData.rejectApp}}</td>

                    <!-- stage 1 start-->
                    <td>{{consolidateData.total_intimation_stage1}}</td>
                    <td>{{consolidateData.verified_intimation_stage1}}</td>
                    <td>{{consolidateData.verified_intimation_stage1_area}}</td>
                    <td>{{consolidateData.pending_intimation_stage1}}</td>

                    <td>{{consolidateData.total_PV_stage1}}</td>
                    <td>{{consolidateData.total_PV_stage1_Area}}</td>
                    <td>{{consolidateData.verified_PV_stage1}}</td>
                    <td>{{consolidateData.verified_PV_stage1_Area}}</td>
                    <td>{{consolidateData.pending_PV_stage1}}</td>
                    <td>{{consolidateData.rejected_PV_stage1}}</td>

                    <td>{{consolidateData.total_subsidy_calc_stage1}}</td>
                    <td>{{consolidateData.total_subsidy_calc_stage1_Area}}</td>
                    <td>{{consolidateData.verified_subsidy_calc_stage1}}</td>
                    <td>{{consolidateData.verified_subsidy_calc_stage1_Area}}</td>
                    <td>{{consolidateData.pending_subsidy_calc_stage1}}</td>
                    <td>{{consolidateData.rejected_subsidy_calc_stage1}}</td>

                    <td>{{consolidateData.total_lot_generated_stage1}}</td>
                    <td>{{consolidateData.verified_lot_generated_stage1}}</td>
                    <td>{{consolidateData.verified_lot_generated_stage1_centershare}}</td>
                    <td>{{consolidateData.verified_lot_generated_stage1_stateshare}}</td>
                    <td>{{consolidateData.pending_lot_generated_stage1}}</td>

                    <td>{{consolidateData.total_subsidy_disbursal_stage1}}</td>
                    <td>{{consolidateData.verified_subsidy_disbursal_stage1}}</td>
                    <td>{{consolidateData.verified_subsidy_disbursal_stage1_centershare}}</td>
                    <td>{{consolidateData.verified_subsidy_disbursal_stage1_stateshare}}</td>
                    <td>{{consolidateData.pending_subsidy_disbursal_stage1}}</td>
                    <!-- stage 1 end -->


                    <!-- stage 2 start -->
                    <td>{{consolidateData.total_intimation_stage2}}</td>
                    <td>{{consolidateData.verified_intimation_stage2}}</td>
                    <td>{{consolidateData.verified_intimation_stage2_area}}</td>
                    <td>{{consolidateData.pending_intimation_stage2}}</td>

                    <td>{{consolidateData.total_PV_stage2}}</td>
                    <td>{{consolidateData.total_PV_stage2_Area}}</td>
                    <td>{{consolidateData.verified_PV_stage2}}</td>
                    <td>{{consolidateData.verified_PV_stage2_Area}}</td>
                    <td>{{consolidateData.pending_PV_stage2}}</td>
                    <td>{{consolidateData.rejected_PV_stage2}}</td>

                    <td>{{consolidateData.total_subsidy_calc_stage2}}</td>
                    <td>{{consolidateData.total_subsidy_calc_stage2_Area}}</td>
                    <td>{{consolidateData.verified_subsidy_calc_stage2}}</td>
                    <td>{{consolidateData.verified_subsidy_calc_stage2_Area}}</td>
                    <td>{{consolidateData.pending_subsidy_calc_stage2}}</td>
                    <td>{{consolidateData.rejected_subsidy_calc_stage2}}</td>

                    <td>{{consolidateData.total_lot_generated_stage2}}</td>
                    <td>{{consolidateData.verified_lot_generated_stage2}}</td>
                    <td>{{consolidateData.verified_lot_generated_stage2_centershare}}</td>
                    <td>{{consolidateData.verified_lot_generated_stage2_stateshare}}</td>
                    <td>{{consolidateData.pending_lot_generated_stage2}}</td>

                    <td>{{consolidateData.total_subsidy_disbursal_stage2}}</td>
                    <td>{{consolidateData.verified_subsidy_disbursal_stage2}}</td>
                    <td>{{consolidateData.verified_subsidy_disbursal_stage2_centershare}}</td>
                    <td>{{consolidateData.verified_subsidy_disbursal_stage2_stateshare}}</td>
                    <td>{{consolidateData.pending_subsidy_disbursal_stage2}}</td>
                    <!-- stage 2 end -->

                    <!-- stage 3 start -->
                    <td>{{consolidateData.total_subsidy_calc_stage3}}</td>
                    <td>{{consolidateData.total_subsidy_calc_stage3_Area}}</td>
                    <td>{{consolidateData.verified_subsidy_calc_stage3}}</td>
                    <td>{{consolidateData.verified_subsidy_calc_stage3_Area}}</td>
                    <td>{{consolidateData.pending_subsidy_calc_stage3}}</td>
                    <td>{{consolidateData.rejected_subsidy_calc_stage3}}</td>

                    <td>{{consolidateData.total_lot_generated_stage3}}</td>
                    <td>{{consolidateData.verified_lot_generated_stage3}}</td>
                    <td>{{consolidateData.verified_lot_generated_stage3_centershare}}</td>
                    <td>{{consolidateData.verified_lot_generated_stage3_stateshare}}</td>
                    <td>{{consolidateData.pending_lot_generated_stage3}}</td>

                    <td>{{consolidateData.total_subsidy_disbursal_stage3}}</td>
                    <td>{{consolidateData.verified_subsidy_disbursal_stage3}}</td>
                    <td>{{consolidateData.verified_subsidy_disbursal_stage3_centershare}}</td>
                    <td>{{consolidateData.verified_subsidy_disbursal_stage3_stateshare}}</td>
                    <td>{{consolidateData.pending_subsidy_disbursal_stage3}}</td>
                    <!-- stage 3 end -->
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">No Data found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
            </ng-template>


        </p-table>
    </div>

    <!-- <div class="mt-2" style="display: flex; justify-content: center;">
        <button pButton pRipple label="Back" icon="pi pi-backward" class="p-button-primary"
            (click)="onClickBack()"></button>
    </div> -->
</div>
<!-- </p-card> -->

<p-dialog class="drilldown_details" [baseZIndex]="-100" header="Consolidated Drill Down Report"
    [(visible)]="displayPendingDetailUser" [modal]="true" [style]="{width: '100%'}" [draggable]="false"
    [resizable]="false">
    <app-drill-down-consolidated-report *ngIf="displayPendingDetailUser"
        [drilldownDetails]="drilldownDetails"></app-drill-down-consolidated-report>
</p-dialog>

<!-- <p-dialog class="drilldown_details" [baseZIndex]="-100" header="Drill Down Consolidated User Wise Report"
    [(visible)]="displayPendingDetailUserWise" [modal]="true" [style]="{width: '100%'}" [draggable]="false"
    [resizable]="false">
    <app-drill-down-consolidated-userwise-report *ngIf="displayPendingDetailUserWise"
        [drilldownDetails]="drilldownDetails"></app-drill-down-consolidated-userwise-report>
</p-dialog> -->